import VuePdfApp from "vue3-pdf-app";
// import this to use default icons for buttons
import "vue3-pdf-app/dist/icons/main.css";

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.component('vue-pdf-app', VuePdfApp);
})